export const PROJECT_HOMEBRIDGE_BRAND_COLOR_PRIMARY = 'rgb(65, 23, 102)';
export const PROJECT_HOMEBRIDGE_BRAND_COLOR_SECONDARY = 'rgb(138, 54, 227)';
